import "./index.css";

import snsWebSdk from "@sumsub/websdk";

/**
 * @param accessToken - access token that you generated on the backend
 */
function launchWebSdk(accessToken, refreshUrl) {
  let snsWebSdkInstance = snsWebSdk
    .init(
      accessToken,
      // token update callback, must return Promise
      // Access token expired
      // get a new one and pass it to the callback to re-initiate the WebSDK
      () => getNewAccessToken(refreshUrl),
    )
    .withConf({
      lang: "en", //language of WebSDK texts and comments (ISO 639-1 format)
      theme: "light",
    })
    .withOptions({ addViewportTag: false, adaptIframeHeight: true })
    // see below what kind of messages WebSDK generates
    .on("idCheck.onStepCompleted", (payload) => {
      console.log("onStepCompleted", payload);
    })
    .on("idCheck.onError", (error) => {
      console.log("onError", error);
    })
    .build();

  // you are ready to go:
  // just launch the WebSDK by providing the container element for it
  snsWebSdkInstance.launch("#sumsub");
}

function getNewAccessToken(url) {
  return fetch(url)
    .then((response) => response.json())
    .then((data) => data.token)
    .catch((error) => console.error(error));
  // return Promise.resolve(newAccessToken); // get a new token from your backend
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const sumsub = document.getElementById("sumsub");

    if (!sumsub) return;

    launchWebSdk(
      sumsub.getAttribute("data-token"),
      sumsub.getAttribute("data-refresh"),
    );
  },
  false,
);
